let elementCounter = 0;
const randomId = function() {
  elementCounter += 1;
  return (/* @__PURE__ */ new Date()).getTime() + elementCounter;
};
export default randomId;
